import React from 'react'
import { Button } from 'hljd'
import {
  AGREE_APPLY_GROUP,
  REFUSE_APPLY_GROUP,
  SIYI_APPLY_AGREE,
  SIYI_APPLY_REFUSE,
  SIYI_APPLY_INVALID
} from '@components/LocalMerchant/SiDa/constant'
import { Flex } from 'hljd'
import Img from '@UI/Img'
import { goToSiYiMemberHome } from '@components/LocalMerchant/SiDa/util'

export default store => [
  {
    title: '',
    dataIndex: ['emcee', 'name'],
    render: (name, { emcee }) => {
      emcee = emcee || {}
      return (
        <Flex
          vc
          style={{ cursor: 'pointer' }}
          onClick={() => goToSiYiMemberHome(emcee.id)}
        >
          <Img
            src={emcee.logoPath}
            style={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              marginRight: 15
            }}
          />
          <div>{name}</div>
        </Flex>
      )
    }
  },
  {
    title: '',
    dataIndex: 'id',
    render: (id, { status }) => {
      let element = null

      if (status == SIYI_APPLY_INVALID) {
        element = '已失效'
      }

      if (status == SIYI_APPLY_AGREE) {
        element = '已加入'
      }

      if (status == SIYI_APPLY_REFUSE) {
        element = '已拒绝'
      }

      return (
        <Flex style={{ justifyContent: 'flex-end' }}>
          {element || (
            <>
              <Button
                type="danger"
                ghost={true}
                onClick={() => store.dealApplyJoin(id, REFUSE_APPLY_GROUP)}
                style={{ marginRight: 10 }}
              >
                拒绝
              </Button>

              <Button
                onClick={() => store.dealApplyJoin(id, AGREE_APPLY_GROUP)}
              >
                同意
              </Button>
            </>
          )}
        </Flex>
      )
    }
  }
]
